export const IMAGE_SIZE_LIMIT_IN_MB = 5;
export const VIDEO_SIZE_LIMT_IN_MB = 16;
export const ONE_MB_IN_BYTES = 1048576;
export const DOCUMENT_SIZE_LIMIT_IN_MB = 1;
